import React from "react";

// core components
import Wizard from "components/Wizard/Wizard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Step1 from "./WizardSteps/Step1.jsx";
import Step2 from "./WizardSteps/Step2.jsx";
import Step3 from "./WizardSteps/Step3.jsx";

class WizardView extends React.Component {
  render() {
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={8}>
          <Wizard
            validate
            steps={[
              { stepName: "General Information", stepComponent: Step1, stepId: "about" },
              { stepName: "Addresses", stepComponent: Step2, stepId: "account" },
              { stepName: "Contacts", stepComponent: Step3, stepId: "address" }
            ]}
            title="Enter a Business Partner"
            subtitle="Use the tabs below to enter new BP information."
          />
        </GridItem>
      </GridContainer>
    );
  }
}

export default WizardView;
